<script lang="ts">
import { defineComponent } from 'vue'

/**
 * JSON-LD BreadcrumbList для SSR.
 *
 * Обычный `<script>` в template Vue вырезает; нужен render с `domProps.innerHTML`.
 * Functional: `props` во втором аргументе `render`, без инстанса.
 */
export default defineComponent({
  // @ts-ignore
  name: 'BreadcrumbsJsonLd',
  functional: true,
  props: {
    json: {
      type: String,
      required: true,
    },
  },
  render(h, { props }) {
    return h('script', {
      attrs: { type: 'application/ld+json' },
      domProps: { innerHTML: props.json },
    })
  },
})
</script>
